import Button from 'components/button/Button';
import { useTranslation } from 'react-i18next';
import { Glyphicon } from 'react-bootstrap';
import useFetchGuestReviewTemplates from 'components/domain/review/useFetchGuestReviewTemplates';
import useAddEditReviewTemplateModal from '../modal/useAddEditReviewTemplateModal';

const AddReviewTemplateButton = () => {
  const { t } = useTranslation();
  const { openAddReviewTemplateModal } = useAddEditReviewTemplateModal();
  const { data: reviewTemplates, isFetching } = useFetchGuestReviewTemplates();
  const isMaxReviewTemplates = reviewTemplates && reviewTemplates.length >= 5;

  // should not show button if we already have 5 review templates:
  if (isMaxReviewTemplates) {
    return null;
  }

  return (
    <Button
      bsStyle="primary"
      data-testid="add-review-template-button"
      onClick={openAddReviewTemplateModal}
      disabled={isFetching}
    >
      <Glyphicon glyph="plus" />
      {t('pageAutomations.reviews.guestReviewTemplates.addReviewTemplate')}
    </Button>
  );
};

export default AddReviewTemplateButton;
